    import React from "react";
import { Modal, Typography } from "antd";
import InspectionBtn from "./InspectionBtn";

const AlertPopup = ({ show, deletelabel = "You want to delete it!", onConfirm, onCancel }) => {
  return (
    <Modal
      title={<Typography.Title level={4}>Are you sure?</Typography.Title>}
      open={show}
      onOk={onConfirm}
      onCancel={onCancel}
      footer={[
        <InspectionBtn key="cancel" onClick={onCancel}>
          Cancel
        </InspectionBtn>,
        <InspectionBtn key="confirm" type="primary" danger onClick={onConfirm}>
          Ok
        </InspectionBtn>
      ]}
    >
      <Typography.Text strong>{deletelabel}</Typography.Text>
    </Modal>
  );
};

export default AlertPopup;
